import { PreviousRouteService } from './../../../Services/previousroute.service';
import { GeolocationService } from './../../../Services/geolocation.service';
import { SubscribtionService } from './../../../Services/subscribtion.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from 'src/app/Services/service.service';
import { FormBuilder } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { CaptchaService } from './../../../Services/captcha.service';
import { AdvEditComponent as AdvEditComponentCore} from './../../../Adveristments/adv-edit/adv-edit.component';
import { Component, ViewChildren, QueryList, ViewChild, ElementRef, ViewEncapsulation, OnInit, AfterViewInit} from "@angular/core";

export enum AdView { Advertisement = 0, Payment = 1 }
export enum AdType { Free = 0, Premium = 1 }

@Component({
  selector: "app-adv-mobile-edit",
  templateUrl: "./advertisement-edit.component.html",
  styleUrls: ["./advertisement-edit.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class AdvEditComponent extends AdvEditComponentCore implements OnInit, AfterViewInit {

  @ViewChildren('emojiscroll') emojiScrollList: QueryList<HTMLElement>;
  
  constructor(captchaService: CaptchaService, HttpClient: HttpClient, fb: FormBuilder, services: MainService, route: ActivatedRoute, subscriptionService: SubscribtionService, geolocationService: GeolocationService, previouseRouteService: PreviousRouteService, router: Router
  ) {
    super(captchaService,HttpClient,fb,services,route,subscriptionService,geolocationService,previouseRouteService,router);
    
   
  }

  ngOnInit(){
    super.ngOnInit();

    if(super.isNew()){
      this.services.pageName = "Add Advertisement";
    }else if(!super.isNew() && !this.SpecialUser && !this.Expired){
      this.services.pageName = "Edit Advertisement";
    }else if(this.SpecialUser && !this.Expired){
      this.services.pageName = "Premium Verified Ad";
    }else if(this.Expired){
      this.services.pageName = "Expired";
    }

    document.getElementById('scroll-view-content').scrollTop =0;
  }

  ngAfterViewInit(){
  }


  scrollView(e){
   
  }
}
